import CreateVocabularyView from "@features/tools/view/vocabularies-view/create-vocabulary-view";

const CreateVocabulary = () => {
  return <CreateVocabularyView />;
};

export default CreateVocabulary;
